import React, { useEffect, useReducer, useRef, useState } from "react";
import Layouts from "./layouts/Layouts";
import { MobileLayout } from "./layouts/MobileLayout/MobileLayout";
import { DesktopLayout } from "./layouts/DesktopLayout/DesktopLayout";
import { useDispatch } from "react-redux";
import { reducer } from "./App.store";
import { loadCoordinates, loadData, loadFloorImages } from "./store/actions";
import { floorImages as allFloorImages } from "./data/floorImages.json";
import "./App.scss";
import { AppContext } from "./context";
import { SCREEN_SIZES } from "./config/constants";

export const App = () => {
  const dispatch = useDispatch();
  const imgMapprRef = useRef()
  document.addEventListener("keydown", function(e) {
    if (
      e.ctrlKey &&
      (e.keyCode === "61" ||
        e.keyCode === "107" ||
        e.keyCode === "173" ||
        e.keyCode === "109" ||
        e.keyCode === "187" ||
        e.keyCode === "189")
    ) {
      e.preventDefault();
    }
  });
  document.addEventListener(
    "wheel",
    function(e) {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    },
    {
      passive: false
    }
  );

  const [appState, setAppState] = useReducer(reducer, {
    activeFloor: "floor-all",
    activeRoomType: [],
    availability: ["1", "0"],
    surfaceVal: { start: 0, end: 0 },
    budgetVal: { start: 0, end: 0 },
    imageIndex: 0,
    isMenuOpen: false,
    secondPage: { filterOpen: false, imageOpen: false },
    viewPort: "1",
    appLoading: true,
    currentImgWith: null,
    currentImgHeight: null,
    imgMapprRef:imgMapprRef
  });
  const [hoveredArea, setHoveredArea] = useState(null);
  const {
    surfaceVal,
    budgetVal,
    activeRoomType,
    availability,
    activeFloor,
    imageIndex,
    appLoading
  } = appState;


  const loadImage = async (image, key) => {
    const img = `${process.env.PUBLIC_URL}/floor/Building1/${key}/${image}`;
    return new Promise((resolve, reject) => {
      const loadImg = new Image();
      loadImg.src = img;
      loadImg.onload = () =>
        setTimeout(() => {
          resolve(img);
        }, 1000);
      loadImg.onerror = (err) => reject(err);
    });
  };

  // const loadAxiono = async (image, key) => {
  //   const img = `${process.env.PUBLIC_URL}/axonos/images/${image}`;
  //   return new Promise((resolve, reject) => {
  //     const loadImg = new Image();
  //     loadImg.src = img;
  //     loadImg.onload = () =>
  //       setTimeout(() => {
  //         resolve(img);
  //       }, 1000);
  //     loadImg.onerror = (err) => reject(err);
  //   });
  // };

  const loadAxiono = () => {
    const images = ["Break-out", "Entrance", "Lift", "Marshalling", "Meeting_room", "Rooftop", "Yard"];
    images.map((item) => {
      const img = `${process.env.PUBLIC_URL}/axonos/images/${item}.webp`;
      const loadImg = new Image();
      loadImg.src = img;
      loadImg.onload = () => {};
      loadImg.onerror = (err) => {};
    });
  };

  useEffect(() => {
    const getAllImages = async () => {
      return Promise.all(
        allFloorImages.map((item) => {
          const key = Object.keys(item)[0];
          return Promise.all(item[key].map((image) => loadImage(image, key)))
            .then((data) => {
            })
            .catch((err) => console.log("Failed to load images", err));
        })
      );
    };
    loadAxiono();
    getAllImages().then(() => {
      setAppState({ prop: "appLoading", value: false });
    });
  }, []);


  function addClass(elements, className) {
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      if (element.classList) {
        element.classList.add(className);
      } else {
        element.className += " " + className;
      }
    }
  }

  function removeClass(elements, className) {
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      if (element.classList) {
        element.classList.remove(className);
      } else {
        element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
      }
    }
  }


  useEffect(() => {
    const canvasElement = document.getElementsByClassName("img-mapper-canvas");
    if (window.innerWidth > SCREEN_SIZES.tablet[1] && hoveredArea && hoveredArea.name.info) {
      addClass(canvasElement, "canvas-hover");
    } else {
      removeClass(canvasElement, "canvas-hover");
    }
  }, [hoveredArea]);


  useEffect(() => {
    dispatch(loadData(activeFloor, 1));
  }, [activeFloor, activeRoomType, availability]);

  useEffect(() => {
    dispatch(loadCoordinates(activeFloor, imageIndex, activeRoomType, availability, surfaceVal, 1, budgetVal));
  }, [activeFloor, imageIndex, activeRoomType, availability, surfaceVal, budgetVal]);

  useEffect(() => {
    dispatch(loadFloorImages(activeFloor));
  }, [activeFloor]);


  return (
    <AppContext.Provider value={appState}>
      <Layouts>
        {(mode) =>
          mode === "desktop" ? (
            <DesktopLayout
              setAppState={setAppState}
              loading={appLoading}
              setHoveredArea={setHoveredArea}
              hoveredArea={hoveredArea}
            />

          ) : (
            <MobileLayout setAppState={setAppState}
                          loading={appLoading}
                          setHoveredArea={setHoveredArea}
                          hoveredArea={hoveredArea} />
          )
        }
      </Layouts>
    </AppContext.Provider>
  );
};
